import dylanhat from '../assets/dylanhat.png';

export default function About() {
  const year = new Date().getFullYear();

  return (
    <div className="relative flex flex-col md:flex-row md:h-screen min-h-screen bg-white text-black">

      {/* Left — text */}
      <div className="flex-1 flex flex-col justify-center px-8 sm:px-12 lg:px-20 pt-24 pb-10 md:py-0">
        <p className="text-[10px] tracking-[0.22em] uppercase text-gray-400 font-medium mb-4">About</p>

        <h1 className="text-5xl sm:text-6xl font-bold leading-[1.05] tracking-tight mb-8">
          About Me
        </h1>

        <div className="space-y-4 text-[15px] leading-relaxed text-gray-500 max-w-lg">
          <p>
            I grew up in Hoboken, New Jersey, and I now live in Midtown Manhattan.
            At 15, I founded{" "}
            <strong className="text-black font-semibold">Computers 4 People</strong>, a non-profit that began
            with a simple goal: to collect unused electronics and provide them to those in need. What started
            as a local effort has grown into a multi-state initiative, donating over 5,000 computers and
            operating the most affordable internet service in the country,{" "}
            <strong className="text-black font-semibold">Shield Internet</strong>.
          </p>

          <p>
            My work has been recognized by the{" "}
            <strong className="text-black font-semibold">Forbes 30 Under 30</strong> list (2025), the 776
            Foundation Fellowship (2025), and honors such as Hoboken Person of the Year (2023), the Diller
            Tikkun Olam Award (2022), and the Aspen Ideas Festival Fellowship (2024).
          </p>

          <p>
            My goal is to donate 1 million computers by 2030. I've been a vegetarian my entire life and
            vegan as of January 1st, 2025 — dedicated to creating lasting impact through technology,
            innovation, and compassion.
          </p>
        </div>
      </div>

      {/* Mobile portrait */}
      <div className="flex md:hidden justify-center px-8 pb-12">
        <img
          src={dylanhat}
          alt="Dylan Zajac"
          className="max-h-[48vh] w-auto object-contain pointer-events-none select-none"
        />
      </div>

      {/* Desktop portrait — pinned to bottom */}
      <div className="hidden md:flex flex-col justify-end items-center flex-shrink-0 w-[40%] xl:w-[36%]">
        <img
          src={dylanhat}
          alt="Dylan Zajac"
          className="max-h-[90vh] w-auto object-contain object-bottom pointer-events-none select-none"
        />
      </div>

      {/* Footer */}
      <p className="absolute bottom-3 left-1/2 -translate-x-1/2 text-[10px] text-gray-300 whitespace-nowrap pointer-events-none hidden md:block">
        © {year} Dylan Zajac. All rights reserved.
      </p>
      <p className="text-[10px] text-gray-300 text-center pb-6 md:hidden">
        © {year} Dylan Zajac. All rights reserved.
      </p>
    </div>
  );
}
